const removeHighlight = '-webkit-tap-highlight-color: transparent'

const webkit = {
  removeHighlight,
}

export default webkit
